import { Checkbox } from "@mui/material";
import DataTable from "../../../../components/DataTable/DataTable";
import EmptyTableSection from "../../../../components/DataTable/EmptyTableSection";
import { getPresentationTypeName } from "../../Index";
import { SRT_STATES } from "../../consts/states";
import { getDate } from "../../../../utils/common";
import { renderStateChipSRT } from "../../RGRL/components/StateChipSRT";
import { TFunction } from "i18next";
import { TEST_IDS } from "../../consts/testIds";
import { columnTitles, columnWidths } from "../consts/table";

interface VisitsTableProps {
    items: any;
    handleItemCheck: (item: any) => void;
    selectedVisits: any[];
    t: TFunction;
    translate: (key: string) => string;
    handleRowClick: any;
    selected: any;
    selectedItemFromAction: any;
    menuOpen: any;
    filters: any;
    setFilters: any;
    isFetching: boolean;
    handleClickAction: any;
}

const VisitsTable = ({
    items,
    handleItemCheck,
    selectedVisits,
    t,
    translate,
    handleRowClick,
    selected,
    selectedItemFromAction,
    menuOpen,
    isFetching,
    filters,
    setFilters,
    handleClickAction
}: VisitsTableProps) => {

    return (
        <>
            {items?.length === 0 ? (
                <EmptyTableSection title={translate('table.noData.title')} />
            ) : (
                <DataTable
                    testID={TEST_IDS.table.visits.id}
                    columnTitles={columnTitles({ translate })}
                    columnWidths={columnWidths}
                    onSelectRow={handleRowClick}
                    selected={selected}
                    selectedItemFromAction={selectedItemFromAction}
                    menuOpen={menuOpen}
                    items={items}
                    loading={isFetching}
                    filters={filters}
                    setFilters={setFilters}
                    isFetching={isFetching}
                    headers={[
                        {
                            type: 'data',
                            upperLabel: (item: any) => (
                                <Checkbox
                                    checked={selectedVisits.some(
                                        (selectedVisit: any) => selectedVisit.id === item.id
                                    )}
                                    disabled={item?.estadoSRT === SRT_STATES.ERROR}
                                    onChange={() => handleItemCheck(item)}
                                />
                            )
                        },
                        {
                            type: 'data',
                            maxWidth: '200px',
                            upperLabel: (item: any) =>
                                item?.establecimiento?.organismo?.contrato?.cuit || '-'
                        },
                        {
                            type: 'data',
                            maxWidth: '250px',
                            upperLabel: (item: any) =>
                                item?.establecimiento?.organismo?.contrato?.nombre || '-'
                        },
                        {
                            type: 'data',
                            maxWidth: '250px',
                            upperLabel: (item: any) => `${item?.establecimiento?.numero} - ${item?.establecimiento?.nombre}`
                        },
                        {
                            type: 'data',
                            maxWidth: '250px',
                            upperLabel: (item: any) =>
                                t(`visits.visitTypes.${item?.tipo}`, {
                                    defaultValue: '-'
                                })
                        },
                        {
                            type: 'data',
                            maxWidth: '250px',
                            upperLabel: (item: any) => getDate(item?.fecha) || '-'
                        },
                        {
                            type: 'data',
                            upperLabel: (item: any) =>
                                renderStateChipSRT(item?.estadoSRT, translate)
                        },
                        {
                            type: 'action',
                            onClick: handleClickAction
                        }
                    ]}
                />
            )}
        </>
    );
};

export { VisitsTable };